"use client";

import { ClipboardPaste, Download, Upload } from "lucide-react";

const STEPS = [
  { icon: Upload, title: "Upload your resume" },
  { icon: ClipboardPaste, title: "Paste the job description" },
  { icon: Download, title: "Download your tailored resume" },
];

export default function HowItWorks() {
  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
          Ready in about two minutes
        </h2>
        <ol className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10">
          {STEPS.map(({ icon: Icon, title }, i) => (
            <li key={title} className="flex items-center gap-3 text-gray-800">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                <Icon className="h-5 w-5" />
              </span>
              <span className="font-medium">
                {i + 1}. {title}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
